module.exports = __webpack_public_path__ + "static/img/10018 (3).24e02ff.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10018 (3).webp
// module id = OyXk
// module chunks = 14